
jQuery(document).ready(function($){

	var spbp = window.matchMedia('screen and (max-width: 576px)'); // スマホのブレイクポイント

	// ページトップ
	$("#pagetop").hide();
	$(window).on("scroll", function() {
		if ($(this).scrollTop() > 100) {
			$("#pagetop").fadeIn("fast");
		} else {
			$("#pagetop").fadeOut("fast");
		}
		scrollHeight = $(document).height(); //ドキュメントの高さ 
		scrollPosition = $(window).height() + $(window).scrollTop(); //現在地 
		footHeight = $(".footer").innerHeight(); //footerの高さ（＝止めたい位置）
		if ( scrollHeight - scrollPosition  <= footHeight ) { //ドキュメントの高さと現在地の差がfooterの高さ以下になったら
			$("#pagetop").css({
				"position":"absolute", //pisitionをabsolute（親：wrapperからの絶対値）に変更
				"bottom": footHeight + 20 //下からfooterの高さ + 20px上げた位置に配置
			});
		} else { //それ以外の場合は
			$("#pagetop").css({
				"position":"fixed", //固定表示
				"bottom": "20px" //下から20px上げた位置に
			});
		}
	});
	$('#pagetop').click(function () {
		$('body,html').animate({
		scrollTop: 0
		}, 400);
		return false;
	});

	// アンカーリンク スクロール
	// #で始まるアンカーをクリックした場合に処理
	$('a[href^="#"]').click(function() {
		// スクロールの速度
		var speed = 400; // ミリ秒
		// アンカーの値取得
		var href= $(this).attr("href");
		var headerHeight = $('.header.fixed').outerHeight();
		href = href.replace(':', '\\:');
		// 移動先を取得
		var target = $(href == "#" || href == "" ? 'html' : href);
		// 移動先を数値で取得
		var position = target.offset().top - headerHeight;
		// スムーススクロール
		$('body,html').animate({scrollTop:position}, speed, 'swing');
		return false;
	});

	// トグル
	$('.hamburger').click(function(){
		$(this).toggleClass('smooth');
		$(this).next('.hamburger-nav').slideToggle(function(){
			$(this).toggleClass('smooth');
		});
	});
	// $('#menu-footer-nav > li > a').click(function(){
	// 	if ( spbp.matches ) {
	// 		$(this).next('ul.sub-menu').slideToggle(function(){
	// 			$(this).toggleClass('smooth');
	// 		});
	// 	}
	// });

	// matchHeight 高さ揃え
	$('.home-cat-title-inner').matchHeight();
	$('.home-cat-item').matchHeight();
	$('.sitemap-cat-title-inner').matchHeight();
	$('.sitemap-cat-item').matchHeight();
	$('.page-archive-lead').matchHeight();
	$('.page-archive-text').matchHeight();
	$('.page-archive2-lead').matchHeight();
	$('.eat10-radio-label').matchHeight();
	$('.energycheck01-check-text').matchHeight();
	$('.product-item-pic').matchHeight();
	$('.product-item-textarea').matchHeight();
	$('.food_name').matchHeight();

	// ヘッダー・フッターのナビのリンク打ち消し
	// $('#menu-footer-nav > li > a').click(function(){
	// 	if ( spbp.matches ) {
	// 		return false;
	// 	}
	// });


	// ヘッダー固定
	var $win = $(window),
			$contents = $('.contents'),
			$nav = $('.header.fixed'),
			navPos = $contents.offset().top,
			$wpadminbar = $('#wpadminbar'), // WordPressヘッダー
			mql = window.matchMedia('screen and (max-width: 600px)'), // WordPressヘッダースマホのメディアクエリ
			fixedClass = 'is-fixed';

	$win.on('load scroll', function() {
		var value = $(this).scrollTop();

		if ( value > navPos ) {
			$nav.addClass(fixedClass);

			if( $wpadminbar.length ) {
				var wpadminbar_height = $wpadminbar.height();

				if ( mql.matches ) {
					$nav.css('cssText', 'top: 0;');
				} else {
					$nav.css('cssText', 'top:' + wpadminbar_height + 'px;');
				}
			} else {
				$nav.css('cssText', 'top: 0;');
			}

		} else {
			$nav.removeClass(fixedClass);
		}
	});

	// タブ
	$('.js-tab-content').hide();
	$('.js-tab-content').eq(0).show();
	$('.js-tab-button').each(function () {
		$(this).on('click', function () {
			$('.js-tab-button').removeClass('active');
			$(this).addClass('active');
			var index = $('.js-tab-button').index(this);
			$('.js-tab-content').hide();
			$('.js-tab-content').eq(index).show();
		});
	});

	// タイプから選ぶ, 目的・状態から選ぶ
	$('#select-type').on('click', function () {
		$('.product-list-title.purpose').removeClass('active');
		if( !( $('.product-list-title.type').hasClass('active') ) ) {
			$('.product-list-title.type').addClass('active');
		}
	});
	$('#select-purpose').on('click', function () {
		$('.product-list-title.type').removeClass('active');
		if( !( $('.product-list-title.purpose').hasClass('active') ) ) {
			$('.product-list-title.purpose').addClass('active');
		}
	});

});

// LINE
//2019.05.28 spice INOUE コメントアウト
//LineIt.loadButton();
